import React, { useEffect, useState } from "react";
import { MAX_PHOTOS_PER_UPLOAD } from "../utils/uploadValidation";

/** Максимум фото одного типа (место / улов / эхолот) за одну отправку — для точки и для комментария. */
export { MAX_PHOTOS_PER_UPLOAD };

export function slicePhotoFiles(fileList) {
    return Array.from(fileList || []).slice(0, MAX_PHOTOS_PER_UPLOAD);
}

/**
 * Миниатюры выбранных файлов до отправки на сервер.
 */
export default function PhotoUploadPreview({ files, onRemove }) {
    const [urls, setUrls] = useState([]);

    useEffect(() => {
        const created = files.map((file) => URL.createObjectURL(file));
        setUrls(created);
        return () => {
            created.forEach((u) => URL.revokeObjectURL(u));
        };
    }, [files]);

    if (!files.length) {
        return null;
    }

    return (
        <div className="photo-upload-preview">
            {files.map((file, index) => (
                <div
                    key={`${file.name}-${file.size}-${file.lastModified}-${index}`}
                    className="photo-upload-preview__item"
                >
                    <img
                        src={urls[index]}
                        alt=""
                        aria-hidden
                        className="photo-upload-preview__item__img"
                    />
                    <button
                        type="button"
                        className="ghost-btn remove-photo-btn"
                        onClick={() => onRemove(index)}
                        aria-label="Убрать фото"
                    >
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <line x1="1" y1="1" x2="9" y2="9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                            <line x1="9" y1="1" x2="1" y2="9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>
            ))}
        </div>
    );
}
